import { render } from "./question2.vue?vue&type=template&id=1087263c&scoped=true"
import script from "./question2.vue?vue&type=script&lang=js"
export * from "./question2.vue?vue&type=script&lang=js"

import "./question2.vue?vue&type=style&index=0&id=1087263c&scoped=true&lang=css"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1087263c"]])

export default __exports__